var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.25C2.96613 7.25 2.125 6.40887 2.125 5.375C2.125 4.34113 2.96613 3.5 4 3.5C5.03387 3.5 5.875 4.34113 5.875 5.375C5.875 5.78919 6.21077 6.125 6.625 6.125C7.03923 6.125 7.375 5.78919 7.375 5.375C7.375 3.77183 6.25103 2.42712 4.75 2.08503V1.25C4.75 0.835812 4.41423 0.5 4 0.5C3.58577 0.5 3.25 0.835812 3.25 1.25V2.08503C1.74897 2.42712 0.625 3.77183 0.625 5.375C0.625 7.23598 2.13902 8.75 4 8.75C5.03387 8.75 5.875 9.59113 5.875 10.625C5.875 11.6589 5.03387 12.5 4 12.5C2.96613 12.5 2.125 11.6589 2.125 10.625C2.125 10.2108 1.78923 9.875 1.375 9.875C0.960766 9.875 0.625 10.2108 0.625 10.625C0.625 12.2282 1.74897 13.5729 3.25 13.915V14.75C3.25 15.1642 3.58577 15.5 4 15.5C4.41423 15.5 4.75 15.1642 4.75 14.75V13.915C6.25103 13.5729 7.375 12.2282 7.375 10.625C7.375 8.76402 5.86098 7.25 4 7.25Z",
    fill: "#556BB8",
    stroke: "#556BB8",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayBlue);
export default __webpack_public_path__ + "static/media/pay-blue.ce3cfa5b84fb278f7680772d57e0c9c6.svg";
export { ForwardRef as ReactComponent };